const parallaxStyle = {
  "@media (max-width: 900px)": {
    parallax: {
      height: "90vh",
      maxHeight: "1000px",
      overflow: "hidden",
      position: "relative",
      backgroundPosition: "100% 100% !important",
      backgroundSize: "contain !important",
      backgroundRepeat: "no-repeat",
      marginBottom: "5vh !important",
      border: "0",
      display: "flex",
      alignItems: "center",
    },
    filter: {
      "&:before": {
        background: "rgba(0, 0, 0, 0.1) !important",
      },
    },
  },

  parallax: {
    height: "90vh",
    maxHeight: "1000px",
    overflow: "hidden",
    position: "relative",
    backgroundPosition: "center center",
    backgroundSize: "cover",
    margin: "0",
    padding: "0",
    border: "0",
    display: "flex",
    alignItems: "center",
  },
  filter: {
    "&:before": {
      background: "rgba(0, 0, 0, 0.1)",
    },
    "&:after,&:before": {
      position: "absolute",
      zIndex: "1",
      width: "100%",
      height: "100%",
      display: "block",
      left: "0",
      top: "0",
      content: "''",
    },
  },
  small: {
    height: "380px",
  },
}

export default parallaxStyle
